import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Column } from '@sm/helpers/simple-flexbox';
import { Panel } from "react-bootstrap";
import { Tooltip } from 'react-tooltip';
import { NavLink } from 'react-router-dom';

import PageHeader from "@sm/components/PageHeader";
import Pagination from '@sm/components/custom/Pagination';
import Spinner from '@sm/components/Spinner';

import '@assets/css/notifications.css';
import NotificationsIcon from '@assets/images/whitelabels.png';
import InfoIcon from '@assets/icons/info.svg';
import ErrorIcon from '@assets/icons/error.svg';
import SuccessIcon from '@assets/icons/success.svg';
import WarningIcon from '@assets/icons/warning.svg';

import * as actions from '@sm/actions';
import { crudActions } from "@sm/services/crudActions";
import { isToday, isYesterday } from '@sm/utils/dateUtils';
class Notifications extends Component {
  state = {
    notifications: [],
    isLoading: true,
    currentPage: 1,
    limit: 20,
    records: null
  };

  componentDidMount() {
    this.getNotifications();
  };

  getNotificationIcon = (type) => {
    switch (type) {
    case "success":
      return SuccessIcon;
    case "warning":
      return WarningIcon;
    case "error":
      return ErrorIcon;
    default:
      return InfoIcon;
    }
  };

  getNotifications = () => {
    const { currentPage, limit } = this.state;
    crudActions.get(`v1/notifications?page=${currentPage}&size=${limit}`, {}, false, true)
      .then(response => {
        this.setState({
          notifications: response.data || [],
          records: response.cnt,
          isLoading: false
        });
        
      })
      .catch(err => {
        this.props.showAlert(true, "error", err?.message);
      });
  };

  onNotificationClick = (notification) => {
    if (!notification?.isRead) {
      this.toggleNotificationState(null, notification);
    }
  };

  toggleNotificationState = (e, notification) => {
    if (e) e.stopPropagation();
    
    const { notifications}  = this.state;
    const currentNotification = notifications.find(n => n.id === notification.id);
    if (!currentNotification) return null;

    const newStatus = !currentNotification.isRead;

    crudActions.put(`v1/notifications/change-status/${currentNotification.id}?isRead=${newStatus}`, {}, {}, false, true)
      .then(() => {
        currentNotification.isRead = newStatus;
        this.setState({ notifications });
      })
      .catch(err => {
        this.props.showAlert(true, "error", err?.message);
      });
  };

  handleChangePage = (event) => {
    const { currentPage } = this.state;
    let pageNum = currentPage;

    if (event.target.getAttribute('data-testid') === "NavigateBeforeIcon"
      || event.target.getAttribute('aria-label') === "Go to previous page") {
      pageNum--;
    } else if (event.target.getAttribute('data-testid') === "NavigateNextIcon"
      || event.target.getAttribute('aria-label') === "Go to next page") {
      pageNum++;
    } else if (event.target.textContent){
      pageNum = event.target.textContent;
    }
   
    this.setState({ currentPage: pageNum }, () => {
      this.getNotifications();
    }); 
  };

  parseDate = (dateString) => {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('.').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes);
  };

  prepareNotifications = () => {
    const { notifications } = this.state;

    const groupedNotifications = notifications.reduce((acc, item) => {
      const parsedDate = this.parseDate(item.dateTime);
      let key;

      if (isToday(parsedDate)) {
        key = 'Today';
      } else if (isYesterday(parsedDate)) {
        key = 'Yesterday';
      } else {
        key = new Date(parsedDate).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      }

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push({ ...item, parsedDate });

      return acc;
    }, {});

    return groupedNotifications;
  };

  render() {
    const {
      currentPage,
      isLoading,
      limit,
      records
    } = this.state;

    const totalPageCount = Math.ceil(records / limit);

    return (
      <Row flexGrow={ 1 } className="module apidata my-account notifications" vertical='start'>
        <Column flexGrow={ 1 }>
          <PageHeader
            title="Notifications"
            img={ NotificationsIcon }
          />
          <Row flexGrow={ 1 } horizontal='end' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    LIST
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  {isLoading ? (
                    <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                      <Spinner smallContainer={ true } />
                    </div>
                  ) : (
                    <>
                      <div className="list">
                        {Object.entries(this.prepareNotifications()).map(([dateLabel, notifications]) => (
                          <div key={ dateLabel }>
                            <h4 className="group-label">
                              { dateLabel }
                            </h4>

                            {notifications.map((notification) => {
                              const NotificationWrapper = notification.url ? NavLink : 'div';
                              const notificationWrapperProps = notification.url ? {
                                to: {
                                  pathname: notification.url,
                                  ...(notification?.state && { state: notification?.state } )
                                } }
                                :
                                {};

                              return (
                                <div
                                  key={ notification.id }
                                  className={ `notification ${notification.type} ${notification.isRead ? 'read' : 'unread'}` }
                                >
                                  <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='center'>
                                    <NotificationWrapper
                                      { ...notificationWrapperProps }
                                      className="notification-link"
                                      onClick={ (e) => this.onNotificationClick(notification) }
                                    >
                                      <div>
                                        <span className="date">{ notification.dateTime }</span>
                                        <span className="text">{ notification.text }</span>
                                      </div>
                                    </NotificationWrapper>
                                    <Tooltip id="toggleNotification" />
                                    <span
                                      className="notification-state"
                                      data-tooltip-id="toggleNotification"
                                      data-tooltip-place="left"
                                      data-tooltip-variant="dark"
                                      data-tooltip-content={ `Mark as ${notification.isRead ? 'un' : ''}read` }
                                      onClick={ (e) => this.toggleNotificationState(e, notification) }
                                    />
                                  </Row>
                                </div>
                              );
                            }
                            )}
                          </div>
                        ))}
                      </div>
                      {totalPageCount > 0 && (
                        <Pagination
                          currentPage={ currentPage }
                          totalPageCount={ totalPageCount }
                          handlePageChange={ this.handleChangePage }
                        />
                      )}
                    </>
                  )}
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(Notifications);
